







































import { Component, Prop, Vue } from 'vue-property-decorator';
import Tabs from '@/components/parts/tab/new/Tabs.vue';
import Description from './components/tabs/description';
import Reviews from './components/tabs/Reviews.vue';
import Place from './components/tabs/place';
import ModulesLayout from './components/tabs/modules';
import Competencies from './components/tabs/competencies';
import Schedule from './components/tabs/schedule';
import Teachers from './components/tabs/teachers';
import Questionnaire from './components/tabs/Questionnaire.vue';
import Sidebar from './components/sidebar';
import VueScrollTo from 'vue-scrollto';
import {
  ComponentProps,
  Locations,
  DescriptionPropsTypes,
  SidebarPropsTypes,
  Modules,
} from './types';

@Component({
  components: {
    Tabs,
    Description,
    Reviews,
    Place,
    Teachers,
    Sidebar,
    Questionnaire,
    ModulesLayout,
    Competencies,
    Schedule,
  },
})
export default class ComponentsPartsCatalogCard
  extends Vue
  implements ComponentProps
{
  // Props
  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Boolean, default: false })
  offsetSetup: false;

  @Prop({ type: Array, default: () => [] })
  geo: Locations;

  @Prop({ type: Number, default: null })
  reviewCount: number;

  @Prop({ type: Object, default: null })
  descriptionProps: DescriptionPropsTypes;

  @Prop({ type: Object, default: null })
  sidebarProps: SidebarPropsTypes;

  @Prop({ type: Array, default: [] })
  teachersList: Array<any>;

  @Prop({ type: Array, default: [] })
  modulesList: Modules;

  @Prop({ type: Number, default: 500 })
  speed: number;

  @Prop({ type: String, default: 'ease-in-out' })
  easing: string;

  @Prop({ type: String, default: 'Description' })
  currentView: string;

  // computed
  get tabs() {
    const permanent: any = [
      {
        sort: 100,
        title: 'Описание',
        component: 'Description',
        props: this.descriptionProps,
      },
      {
        sort: 120,
        title: 'Модули',
        component: 'ModulesLayout',
        props: { modules: this.modulesList },
      },
      {
        sort: 160,
        title: 'Расписание',
        component: 'Schedule',
      },
      {
        sort: 300,
        title: 'Отзывы',
        component: 'Reviews',
        count: this.reviewCount,
      },
    ];

    if (this.teachersList.length) {
      permanent.push({
        sort: 250,
        title: 'Преподаватели',
        component: 'Teachers',
        props: { list: this.teachersList },
      });
    }

    if (this.geo && this.geo.length) {
      permanent.push({
        sort: 400,
        title: 'Место на карте',
        component: 'Place',
        props: { title: this.title, geo: this.geo },
      });
    }
    if (this.$store.getters.hasApiModulesNoko) {
      permanent.push({
        sort: 350,
        title: 'Анкета',
        component: 'Questionnaire',
      });
    }

    return permanent;
  }

  get navResult() {
    return this.tabs.sort((a: any, b: any) => a.sort - b.sort);
  }

  get containPlace() {
    return !!this.tabs.find((item: any) => item.component === 'Place');
  }

  // methods
  showPlace() {
    const { speed, easing, offsetSetup } = this;
    VueScrollTo.scrollTo('.tabs-container', speed, {
      offset: offsetSetup ? -130 : -80,
      easing,
    });
    if (this.containPlace) {
      this.$emit('tab-changed', 'Place');
    }
  }

  tabHandler(name: string) {
    this.$emit('tab-changed', name);
    if (name === 'Reviews') this.$emit('need-reviews');
    if (name === 'Questionnaire') this.$emit('need-questionnaire');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/Card.vue